import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Remove Driver',
        defaultMessage: 'Remove Driver',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Drivers',
        defaultMessage: 'Are you sure you want to remove this Driver from the list?',
    }
});